import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { SUPPLIER_CATS } from "./SupplierCard";

const EMPTY = { name: "", contact: "", phone: "", email: "", tax_number: "", tax_office: "", category: "GIDA", payment_term_days: 30 };

export default function SupplierForm({ open, onClose, item, onSaved }) {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) setForm(item ? { ...EMPTY, ...item } : EMPTY); }, [open, item]);

  const save = async () => {
    if (!form.name.trim()) { toast.error("Firma adı gerekli"); return; }
    setSaving(true);
    try {
      const payload = { ...form, payment_term_days: parseInt(form.payment_term_days, 10) || 0 };
      ["id", "debit", "credit", "balance", "created_at"].forEach((k) => delete payload[k]);
      if (item) { await api.put(`/suppliers/${item.id}`, payload); toast.success("Tedarikçi güncellendi"); }
      else { await api.post("/suppliers", payload); toast.success("Tedarikçi eklendi"); }
      onClose(); onSaved();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle className="font-heading">{item ? "Tedarikçi Düzenle" : "Yeni Tedarikçi"}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 py-2">
          <F label="Firma Adı *" className="sm:col-span-2"><Input value={form.name} onChange={set("name")} data-testid="supplier-form-name" /></F>
          <F label="Kategori">
            <Select value={form.category} onValueChange={(v) => setForm({ ...form, category: v })}>
              <SelectTrigger data-testid="supplier-form-category"><SelectValue /></SelectTrigger>
              <SelectContent>{Object.entries(SUPPLIER_CATS).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
            </Select>
          </F>
          <F label="Yetkili"><Input value={form.contact} onChange={set("contact")} data-testid="supplier-form-contact" /></F>
          <F label="Telefon"><Input value={form.phone} onChange={set("phone")} data-testid="supplier-form-phone" /></F>
          <F label="E-posta"><Input type="email" value={form.email} onChange={set("email")} data-testid="supplier-form-email" /></F>
          <F label="Vergi Dairesi"><Input value={form.tax_office} onChange={set("tax_office")} data-testid="supplier-form-tax-office" /></F>
          <F label="Vergi No"><Input value={form.tax_number} onChange={set("tax_number")} data-testid="supplier-form-tax-number" className="font-mono" /></F>
          <F label="Ödeme Vadesi (gün)"><Input type="number" value={form.payment_term_days} onChange={set("payment_term_days")} data-testid="supplier-form-term" className="font-mono" /></F>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>İptal</Button>
          <Button onClick={save} disabled={saving} data-testid="supplier-form-save" className="gap-2">{saving && <Loader2 className="h-4 w-4 animate-spin" />} Kaydet</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

const F = ({ label, children, className = "" }) => (
  <div className={`space-y-2 ${className}`}><Label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</Label>{children}</div>
);
